import EA from '../helpers/init';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default EA.Methods.newsSwiper = ($this) => {
    const swiperEl = $this.querySelector('.swiper-container');
    const prev = $this.querySelector('.swiper-button-prev');
    const next = $this.querySelector('.swiper-button-next');

    new Swiper( swiperEl, {
        speed: 1000,
        loop: true,
        modules: [Navigation],
        slidesPerView: 1.1,
        spaceBetween: 16,
        navigation: {
            nextEl: next,
            prevEl: prev,
        },
        breakpoints: {
            1000: {
                slidesPerView: 'auto',
                spaceBetween: 56
            },
            1400: {
                slidesPerView: 3,
                spaceBetween: 56
            }
        }
    });
};
